import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {EventItem, Lookups} from "@model";
import {AbstractComponent} from "../abstract.component";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'share-modal',
  templateUrl: './share-modal.component.html',
  styleUrls: ['./share-modal.component.scss']
})
export class ShareModalComponent extends AbstractComponent {
  @Input() eventItem?: EventItem;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() isShareVisible?: boolean = false;

  constructor(public activeModal: NgbActiveModal, public translocoService: TranslocoService,) {
    super();

  }
}
